(() => {
  'use strict';
  function init(root) {
    if (root.dataset.tvReady) return;
    root.dataset.tvReady = 'true';
    const power = root.querySelector('[data-tv-power]');
    const screen = root.querySelector('[data-tv-screen]');
    const off = root.querySelector('[data-tv-off]');
    const status = root.querySelector('[data-tv-status]');
    const external = root.querySelector('[data-tv-external]');
    const channels = Array.from(root.querySelectorAll('[data-tv-channel]'));
    let selected = channels[0], on = false;
    function render() {
      screen.querySelector('iframe')?.remove();
      off.hidden = on;
      root.classList.toggle('nye-tv-is-on', on);
      power.setAttribute('aria-pressed', String(on));
      power.innerHTML = '<span aria-hidden="true">⏻</span> POWER ' + (on ? 'OFF' : 'ON');
      const title = selected.dataset.tvTitle;
      status.textContent = (on ? 'Tuned to: ' : 'Ready: ') + title;
      external.href = 'https://www.youtube.com/watch?v=' + selected.dataset.tvChannel;
      channels.forEach(button => button.setAttribute('aria-pressed', String(button === selected)));
      if (!on) return;
      const frame = document.createElement('iframe');
      frame.title = 'NyeTV: ' + title;
      frame.src = 'https://www.youtube-nocookie.com/embed/' + selected.dataset.tvChannel + '?autoplay=1&playsinline=1&rel=0';
      frame.allow = 'autoplay; encrypted-media; picture-in-picture; fullscreen';
      frame.allowFullscreen = true;
      frame.referrerPolicy = 'strict-origin-when-cross-origin';
      screen.append(frame);
    }
    power.hidden = false;
    channels.forEach(button => {
      button.hidden = false;
      button.addEventListener('click', () => {
        if (selected === button) return;
        selected = button;
        render();
      });
    });
    power.addEventListener('click', () => { on = !on; render(); });
    // Returning from browser history must not restart audio unexpectedly.
    window.addEventListener('pagehide', () => { on = false; render(); });
  }
  document.querySelectorAll('[data-nye-tv]').forEach(init);
  document.addEventListener('shopify:section:load', event => event.target.querySelectorAll('[data-nye-tv]').forEach(init));
})();
